import React from 'react';
import { BRAND_LOGO_512_URL } from '../../config/brandAssets';

const SEO = ({ title, description, keywords, canonical, image, type = 'website', article }) => {
  React.useEffect(() => {
    // Actualizar el título de la página
    if (title) {
      document.title = title;
    }

    // Actualizar meta tags
    const updateMetaTag = (name, content) => {
      let meta = document.querySelector(`meta[name="${name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.name = name;
        document.head.appendChild(meta);
      }
      meta.content = content;
    };

    const updateMetaProperty = (property, content) => {
      let meta = document.querySelector(`meta[property="${property}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('property', property);
        document.head.appendChild(meta);
      }
      meta.content = content;
    };

    // Meta tags básicos
    if (description) {
      updateMetaTag('description', description);
      updateMetaProperty('og:description', description);
    }

    if (keywords) {
      updateMetaTag('keywords', keywords);
    }

    // Open Graph tags
    if (title) {
      updateMetaProperty('og:title', title);
    }

    updateMetaProperty('og:type', type);
    updateMetaProperty('og:site_name', 'E-ASY');
    
    // Open Graph URL
    if (canonical) {
      updateMetaProperty('og:url', canonical);
    }
    
    // Open Graph Image
    const ogImage = image || BRAND_LOGO_512_URL;
    updateMetaProperty('og:image', ogImage);
    updateMetaProperty('og:image:alt', title || 'E-ASY - Consultoría Tecnológica');

    // Canonical URL
    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.rel = 'canonical';
        document.head.appendChild(link);
      }
      link.href = canonical;
    }

    // Twitter Card tags
    updateMetaTag('twitter:card', 'summary_large_image');
    if (title) {
      updateMetaTag('twitter:title', title);
    }
    if (description) {
      updateMetaTag('twitter:description', description);
    }
    if (canonical) {
      updateMetaTag('twitter:url', canonical);
    }
    updateMetaTag('twitter:image', ogImage);
    updateMetaTag('twitter:image:alt', title || 'E-ASY - Consultoría Tecnológica');

    // Article specific meta tags (for blog posts)
    if (type === 'article' && article) {
      if (article.publishedTime) {
        updateMetaProperty('article:published_time', article.publishedTime);
      }
      if (article.modifiedTime) {
        updateMetaProperty('article:modified_time', article.modifiedTime);
      }
      if (article.author) {
        updateMetaProperty('article:author', article.author);
      }
      if (article.section) {
        updateMetaProperty('article:section', article.section);
      }
      if (article.tags && article.tags.length > 0) {
        article.tags.forEach((tag, index) => {
          updateMetaProperty(`article:tag`, tag);
        });
      }
    }

    // Cleanup function
    return () => {
      // No necesitamos limpiar nada ya que solo estamos actualizando meta tags existentes
    };
  }, [title, description, keywords, canonical, image, type, article]);

  return null; // Este componente no renderiza nada en el DOM
};

export default SEO;
